module.exports = __webpack_public_path__ + "static/media/bronze-daily.2fd30dc6.svg";